/* Tailwind を含むスタイル。**最初に読む**——後続の import が作る
   コンポーネントより先にスタイルを確定させる。 */
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import App from './App';
import { ToastContainer } from './components/ToastContainer';
import { installGlobalErrorHandlers } from './services/errorReporter';
import { captureCheckoutReturn } from './services/checkoutReturn';

/* 捕まえていない例外と Promise の失敗を残す。**描画の前に入れる。**
   起動時に落ちたときこそ記録が要る。 */
installGlobalErrorHandlers();
/* Stripe からの戻りを **React より前に** 控える。App の初期化が
   history.replaceState を pathname だけで呼ぶため、後から読もうとしても
   クエリはもう消えている。 */
captureCheckoutReturn();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
    {/* App.tsx は view ごとに早期 return するので、トーストは App の外に置く */}
    <ToastContainer />
    <Analytics />
  </React.StrictMode>
);
